import mitt from 'mitt'

type ChannelProps = {
  showNearestResults: () => void
  footerInView: boolean
}

export const mapEventChannel = mitt<ChannelProps>()
